import { render, staticRenderFns } from "./PackageResource.vue?vue&type=template&id=1257aaed&scoped=true&"
import script from "./PackageResource.vue?vue&type=script&lang=js&"
export * from "./PackageResource.vue?vue&type=script&lang=js&"
import style0 from "./PackageResource.vue?vue&type=style&index=0&id=1257aaed&lang=scss&scoped=true&"
import style1 from "./PackageResource.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1257aaed",
  null
  
)

export default component.exports